// test2196
(2196 && 0);
